module.exports = __webpack_public_path__ + "images/img-4eww829.png";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/keitaro-integration/en/9.png
// module id = 2345
// module chunks = 0